import React from 'react'
import '../../styles/testimonial.css'

const technologyData = [
    {
        icon: 'ri-flashlight-line',
        title: 'Innovative Technology',
        desc: 'Using hot alkaline vapor to detect and classify tiny magnetic disturbances',
        color: '#00d4ff'
    },
    {
        icon: 'ri-pulse-line',
        title: 'Sensitivity',
        desc: 'Measure magnetic fields (pT) using a highly sensitive vector quantum gradiometer',
        color: '#ff6b6b'
    },
    {
        icon: 'fontisto-atom',
        title: 'Quantum Physics Principles',
        desc: 'Gradiometer sensor based on quantum physics principles',
        color: '#4ecdc4'
    },
    {
        icon: 'ri-focus-3-line',
        title: 'Accuracy',
        desc: 'Accurately detect and track land, air and underwater vehicles at a depth of 500 meters',
        color: '#ffd93d'
    },
]

export default function Testimonial() {
  return (
    <section id='blog'>
        <div className="container">
            <div className="content-header">
                {/* <div className="header-badge">Technology Overview</div> */}
                <h2 className="main-title">
                    The Product <span className="highlight">Technology</span>
                </h2>
                <p className="subtitle">
                    Measuring the absorption change / polarization rotation of light 
                    in the presence of an external magnetic field
                </p>
            </div>
            
            <div className="features-grid">
                {technologyData.map((item, index) => (
                    <div 
                        className="feature-card" 
                        key={index}
                        style={{ '--card-color': item.color, '--animation-delay': `${index * 0.1}s` }}
                    >
                        <div className="card-glow"></div>
                        <div className="feature-icon">
                            <i className={item.icon} />
                        </div>
                        <h3 className="feature-title">{item.title}</h3>
                        <p className="feature-desc">{item.desc}</p>
                        <div className="card-number">0{index + 1}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
  )
}